import React from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import NavbarSearch from "../../layouts/header/NavbarSearch";
import FourIcon from "../../atoms/icons/FourIcon";
import NotFoundIcon from "../../atoms/icons/NotFoundIcon";

import { staticTexts } from "../../utils/Translate";

import "./not-found.m.css";

const NotFoundPageBase = ({ lang }) => (
  <div styleName="wrapper">
    <div styleName="status">
      <FourIcon />
      <NotFoundIcon />
      <FourIcon />
    </div>
    <h1>{staticTexts(lang).noResultsFound}</h1>
    <p styleName="no-results-breif">{staticTexts(lang).noResultsBreif}</p>
    <NavbarSearch lang={lang} />
    <div styleName="cover-button">
      <Link aria-label={staticTexts(lang).cover} href="/">
        {staticTexts(lang).cover}
      </Link>
    </div>
  </div>
);

NotFoundPageBase.propTypes = {
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export const NotFoundPage = connect(mapStateToProps)(NotFoundPageBase);
